/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Grid } from '@material-ui/core';
import { FeaturePageHeader } from 'components/shell/FeaturePageShell';
import IntlMessages from 'util/IntlMessages';
import SearchFeaturePageShell from 'components/shell/SearchFeaturePageShell';
import QueryTimeline from './QueryTimeline';
import RelatedQueries from './RelatedQueries';
import RelatedProducts from './RelatedProducts';

export const QueryDetailContent = ({ match, showHeader = false }) => (
  <Grid>
    {showHeader && (
      <FeaturePageHeader
        title={<IntlMessages id="search.page.analyticQueryDetail.title" />}
      />
    )}
    <Grid spacing={4} container>
      <Grid item xs={12} lg={8}>
        <Grid item xs={12}>
          <QueryTimeline match={match} />
        </Grid>
      </Grid>
      <Grid item xs={12} lg={4}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <RelatedQueries match={match} />
          </Grid>
          <Grid item xs={12}>
            <RelatedProducts match={match} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

const QueryDetail = ({ match, embedded = false }) => {
  const content = <QueryDetailContent match={match} showHeader={embedded} />;
  if (embedded) return content;

  return (
    <SearchFeaturePageShell pageId="analyticQueryDetail">
      {content}
    </SearchFeaturePageShell>
  );
};

export default QueryDetail;
